var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0132 11.001V40.392L19.4652 61.894C22.9137 65.4474 27.1882 68.092 31.9074 69.5918C36.6265 71.0916 41.6435 71.3999 46.5108 70.4893C51.378 69.5787 55.9442 67.4775 59.802 64.373C63.6597 61.2686 66.689 57.2575 68.6196 52.6977C70.5503 48.1378 71.3222 43.171 70.8665 38.2403C70.4108 33.3096 68.7418 28.5683 66.0082 24.4395C63.2746 20.3107 59.5615 16.9227 55.2002 14.5779C50.8388 12.233 45.9649 11.0042 41.0132 11.001V11.001Z",
    fill: "#2F64F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3405 39.4551V10.0011C33.4084 9.94996 27.5937 11.6543 22.6278 14.8998C17.662 18.1452 13.7669 22.7868 11.4325 28.2405C9.09813 33.6942 8.4288 39.7165 9.50869 45.5497C10.5886 51.3829 13.3695 56.7665 17.5015 61.0231L39.3405 39.4551Z",
    fill: "#93B5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.5e2ddd90d01df2f4e3262e2a85b726a1.svg";
export { ForwardRef as ReactComponent };